import { render, staticRenderFns } from "./FrequencyUse.vue?vue&type=template&id=34b4d41e&scoped=true&"
import script from "./FrequencyUse.vue?vue&type=script&lang=js&"
export * from "./FrequencyUse.vue?vue&type=script&lang=js&"
import style0 from "./FrequencyUse.vue?vue&type=style&index=0&id=34b4d41e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34b4d41e",
  null
  
)

export default component.exports